import { render } from "./UpdatePinRobot.vue?vue&type=template&id=6be00bb3&scoped=true"
import script from "./UpdatePinRobot.vue?vue&type=script&lang=js"
export * from "./UpdatePinRobot.vue?vue&type=script&lang=js"

import "./UpdatePinRobot.vue?vue&type=style&index=0&id=6be00bb3&scoped=true&lang=css"

import exportComponent from "D:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be00bb3"]])

export default __exports__